module.exports = __webpack_public_path__ + "assets/img/04b.b1ff313d.jpg";